import type { RobisFormConfig } from '#types/config/components/form/robis'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    cta: 'mt-6 w-full',
    form: 'px-4 py-3 bg-grey-90',
    heading: 'subtitle-2',
    inputsWrapper: 'mb-6 mt-3 space-y-2',
    requiredField: 'text-xs c-grey-20'
  },
  separateNameFields: true
} satisfies RecursivePartial<RobisFormConfig>
